package com.eladfinish.bible.contest.screens.search.usecases.root

import com.eladfinish.bible.contest.screens.search.model.VerseUiModel
import dev.icerock.moko.resources.desc.StringDesc
import kotlinx.collections.immutable.ImmutableList

data class SearchRootUiResult(
    val results: ImmutableList<VerseUiModel>,
    val report: StringDesc,
)
